import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../../../../atomic/buttons/textButton/TextButton';
import { labelMap } from '../../../detailsUtils/tabMap';
import style from './AddTacticPanel.module.css';
const exitTacticsList = [
  'BREAK_PRICE',
  'CANDLE_TRAIL',
  'GRAB_CENTS',
  'GREEN_TO_RED_CANDLES',
  'GREEN_TO_RED_POSITIONS',
  'LOSS_LIMIT',
  'POSITION_PRICE_TRAIL',
  'UNDERLYING_PRICE_TRAIL',
  'PRESERVE_PROFIT',
  'RATCHET_BRACKET',
  'CANDLE_MAGNITUDE',
  'ATR_TRAIL',
  'MFE_RETRACEMENT',
  'UNDERLYING_PRICE_EXIT',
  'POSITION_BREAK_PRICE',
];
export const AddTacticPanel = ({
  tradePlanId,
  // eslint-disable-next-line no-unused-vars
  softOrderId,
  addTab,
  ...rest
}) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const exitTactics = tradePlan.exitTactics;
  const [selection, setSelection] = useState('default');
  return (
    <TabPanel {...rest}>
      <div className={style.container}>
        <div className={style.innerContainer}>
          <select
            value={selection}
            onChange={({ target }) => setSelection(target.value)}
          >
            {exitTacticsList.map((tactic) => {
              if (tactic === 'RATCHET_BRACKET') {
                if (
                  exitTactics['CANDLE_MAGNITUDE'] ||
                  exitTactics['GRAB_CENTS'] ||
                  exitTactics['RATCHET_BRACKET']
                )
                  return null;
                else
                  return (
                    <option key={tactic} value={tactic}>
                      {labelMap[tactic]}
                    </option>
                  );
              } else if (tactic === 'CANDLE_MAGNITUDE') {
                if (
                  exitTactics['RATCHET_BRACKET'] ||
                  exitTactics['GRAB_CENTS'] ||
                  exitTactics['CANDLE_MAGNITUDE']
                )
                  return null;
                else
                  return (
                    <option key={tactic} value={tactic}>
                      {labelMap[tactic]}
                    </option>
                  );
              } else if (tactic === 'GRAB_CENTS') {
                if (
                  exitTactics['RATCHET_BRACKET'] ||
                  exitTactics['CANDLE_MAGNITUDE'] ||
                  exitTactics['GRAB_CENTS']
                )
                  return null;
                else
                  return (
                    <option key={tactic} value={tactic}>
                      {labelMap[tactic]}
                    </option>
                  );
              } else if (tactic === 'UNDERLYING_PRICE_TRAIL' || tactic === 'POSITION_BREAK_PRICE') {
                if (tradePlan.instrument === 'option')
                  return (
                    <option key={tactic} value={tactic}>
                      {labelMap[tactic]}
                    </option>
                  );
                else return null;
              } else {
                if (exitTactics[tactic]) return null;
                else
                  return (
                    <option key={tactic} value={tactic}>
                      {labelMap[tactic]}
                    </option>
                  );
              }
            })}
            <option value="default">Select a tactic...</option>
          </select>
          <TextButton
            clickHandler={() => {
              if (selection !== 'default' && !exitTactics[selection])
                addTab(`ADD_${selection}`, 'none', 'addTactic');
            }}
            color={colors.lightGrey}
            backgroundColor={colors.blue}
            fontSize="medium"
            width="90px"
            height="fit-content"
          >
            Add Tactic
          </TextButton>
        </div>
      </div>
    </TabPanel>
  );
};

AddTacticPanel.propTypes = {
  addTab: PropTypes.func,
  softOrderId: PropTypes.any,
  tradePlanId: PropTypes.any,
};

AddTacticPanel.tabsRole = 'TabPanel';
